export enum ProgramMode {
  REGULAR = 'REGULAR',
  PART_TIME = 'PART_TIME',
  BRIDGE = 'BRIDGE',
  LIFELONG = 'LIFELONG',
}
